var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[(_vm.$i18n.locale === 'ru')?_c('footer-subscribe-form'):_vm._e(),_vm._v(" "),_c('footer-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }